import { Component, ViewChild, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { Globals } from '../../../globals';
import { MatMenuTrigger } from '@angular/material';
import { DeviceDetectorService } from 'ngx-device-detector';
import { GeneralService } from '../../../providers/general.service';
import { TemaService } from '../../../providers/tema.service';
import { ConfiguracionEmpresaService } from '../../../providers/configuracion-empresa.service';
import { LogueadoComponent } from '../../../pages/logueado/logueado.component';
import { TareaService } from '../../../providers/tarea.service';
import { NotificacionService } from '../../../providers/notificacion.service';

@Component({
  selector: 'app-modulos',
  templateUrl: './modulos.component.html',
  styleUrls: ['./modulos.component.scss']
})
export class ModulosComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('menuWebTrigger') menuWebTrigger: MatMenuTrigger;
  @ViewChild('menuProduccionTrigger') menuProduccionTrigger: MatMenuTrigger;

  /**
   * Se utiliza para no abrir el menú si se cerró porque hicieron click en una opción y no porque alejaron el mouse
   */
  preventAutoOpen: number = -1;
  tema: String = '';
  logo: String = '';
  logoConf: 'icono' | 'imagen' = 'icono';
  segundos = 50;
  cliente:any;
  contadoresBadge: any;
  buscarContadores: any;
  constructor(
    public globals: Globals,
    public deviceService: DeviceDetectorService,
    private general: GeneralService,
    private temaServicio: TemaService,
    private _confSv: ConfiguracionEmpresaService,
    private tareaService: TareaService,
    private notificacionService: NotificacionService

  ) {
    this.notificacionService.configuracion.subscribe((r: any) => {
      this.logo = r.empresa.logo;
      this.logoConf = 'imagen';
    });
    this.cliente=localStorage.getItem('idCliente');
  }


  ngOnInit() {

    this.getTemaSelected();
    this.checkTareasPendientesLoop();

  }

  ngAfterViewInit() {
    this.getLogo();
  }
  getLogo() {
    this._confSv.getConfiguracion().subscribe(
      resp => {
        if (resp.data) {
          if (resp.data.logo != '' && resp.data.logo != undefined) {
            this.logo = resp.data.logo;
            this.logoConf = 'imagen';
          } else {
            this.logo = this.general.boton_home_logo;
            this.logoConf = 'icono';
          }
        } else {
          throw "Error al obtener logo";
        }
      }
    );
  }
  getTemaSelected() {
    this.temaServicio.tema.subscribe((temaSeleccionado) => {
      this.tema = temaSeleccionado
    });
  }

  openMenu(modulo: string) {
    // si pasaron mas de 200ms desde que fue cerrado, lo abrimos
    if (this.preventAutoOpen == -1 || ((new Date().getTime()) - this.preventAutoOpen) > 300) {
      switch (modulo) {
        case 'web':
          this.menuWebTrigger.openMenu();
          break;
        case 'produccion':
          this.menuProduccionTrigger.openMenu();
          break;
      }
    }
  }

  closeMenu(modulo: string) {
    switch (modulo) {
      case 'web':
        this.menuWebTrigger.closeMenu();
        break;
      case 'produccion':
        this.menuProduccionTrigger.closeMenu();
        break;
    }

    // guardar fecha que se cerró el menú
    this.preventAutoOpen = new Date().getTime();
  }
  checkTareasPendientesLoop(): void {
    // Checkear si hay notificaciones loop
    setTimeout(() => {
      this.badgesPages();
    }, 1750);

    this.buscarContadores = setInterval(() => {
      this.badgesPages();
    }, this.segundos * 1000);
  }
  badgesPages() {
    this.tareaService.getContadores().subscribe(
      respuesta => {
        this.contadoresBadge = respuesta.data;
        // console.log(this.contadoresBadge);

      }
    )
  }
  ngOnDestroy(): void {
    // al desloguearse dejar de buscar notificaciones
    clearInterval(this.buscarContadores);
    // this._confSv.configuracion.unsubscribe();
  }
}
